var render = function render(){var _vm=this,_c=_vm._self._c;return _c('esg-table-without-meta',{attrs:{"fields":_vm.fields,"items":_vm.items,"filter":false,"max-height":"300px","size":"sm"},scopedSlots:_vm._u([{key:"cell(category)",fn:function({item, items, field, row, col, value}){return [(item.rowspan)?_c('td',[_vm._v(_vm._s(value))]):_c('td',{staticStyle:{"border-top":"none"}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }